"use strict";

var _createForOfIteratorHelper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addNackSuppportForOpus = void 0;
/**
 * This function adds RTCP NACK support for OPUS codec in given capabilities.
 */

function addNackSuppportForOpus(rtpCapabilities) {
  var _a;

  var _iterator = _createForOfIteratorHelper(rtpCapabilities.codecs || []),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var codec = _step.value;

      if ((codec.mimeType.toLowerCase() === 'audio/opus' || codec.mimeType.toLowerCase() === 'audio/multiopus') && !((_a = codec.rtcpFeedback) === null || _a === void 0 ? void 0 : _a.some(function (fb) {
        return fb.type === 'nack' && !fb.parameter;
      }))) {
        if (!codec.rtcpFeedback) {
          codec.rtcpFeedback = [];
        }

        codec.rtcpFeedback.push({
          type: 'nack'
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

exports.addNackSuppportForOpus = addNackSuppportForOpus;